import { useTranslation } from 'react-i18next';
import { X } from '@/design-system/icons';
import { SidepanelProps } from './types';
import { useState, useEffect } from 'react';

export function Sidepanel({
  isOpen,
  onClose,
  children,
  title,
  className = ''
}: SidepanelProps) {
  const { t } = useTranslation();

  const [isOpenState, setIsOpenState] = useState(false);

  useEffect(() => {
    setIsOpenState(isOpen);
    document.body.classList.toggle('overflow-hidden', isOpen);
    return () => document.body.classList.remove('overflow-hidden');
  }, [isOpen]);

  return (
    <>
      {isOpenState && (
        <div
          className="fixed inset-0 bg-black/50 z-50"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      <aside
        className={`
          transition-transform duration-300 transform
          h-full
          fixed inset-y-0 end-0 z-60
          bg-surface border-s border-border
          w-full
          sm:w-[72vw] sm:min-w-[460px] lg:w-[56vw]
          ${isOpenState ? 'translate-x-0' : 'translate-x-full'}
          ${className}`}
        tabIndex={-1}
        aria-label={title}
      >
        <div className="relative flex flex-col h-full max-h-full w-full">
          <header className="relative h-12 px-4 flex items-center justify-between border-b border-border">
            {title && (
              <h2 className="text-lg font-semibold text-onsurface">
                {title}
              </h2>
            )}
            <button
              type="button"
              className="size-8 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-border bg-surface text-onsurface hover:bg-surface-darker focus:outline-none focus:bg-surface-darker disabled:opacity-50 disabled:pointer-events-none ms-auto"
              onClick={onClose}
              aria-label={t('common.close')}
            >
              <X className="size-4" />
            </button>
          </header>

          <div className="relative flex-1 overflow-y-auto flex h-full w-full flex-col">
            {children}
          </div>
        </div>
      </aside>
    </>
  );
}
